import React, { useState } from 'react'
import DropMenu from 'blocks.simple/dropMenu/dropMenu'
import Button from 'blocks.simple/button/button'
import config from 'core/config'
import styles from './catalog__filter_instancesCatalog.jcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { text as textStyles } from 'theme'
import translate from 'core/translate'
import { cn } from 'ethcss'
import { connect } from 'react-redux'
import { loaderActions } from 'features/loader/Loader.state'
import { getUser } from '../../../../core/helpers/user'
import { isHorizontalMenu } from 'core/helpers/menu'
import Icon from '../../../../blocks.simple/icon/icon'
import ModalWithBackground from 'blocks.simple/modalWithBackground/modalWithBackground'
import Uploader from 'blocks.app/uploader'
import { ApiPostEventsType } from 'core/api/events'

export interface IInstancesCatalogProps {
    tokens: { accessToken: string; refreshToken: string }
    selectedItems: { id: number; productCode?: string }[]
    fakeLine?: string
    onDelete: () => void
    type: string
    upload?: string
    acceptFiles?: string
    startLoading: () => void
    endLoading: () => void
    title: string
    onAdd?: any
    onAddFakeLine?: any
}

const InstancesCatalogFilter = (p_: IInstancesCatalogProps) => {
    const [active, setActive] = useState<string[]>([])
    const [openUploadModal, setOpenUploadModal] = useState(false)

    const getHeadersByType = (type: string): { [key: string]: string } => {
        const { tokens } = p_

        switch (type) {
            case 'wine':
                return {
                    Authorization: `Bearer ${tokens.accessToken}`,
                }
            default:
                return {}
        }
    }
    const deleteItem = () => {
        return {
            id: 'delete',
            icon: 'delete',
            disabled: p_.selectedItems.length === 0 && !p_.fakeLine,
            color: 'darkCloud',
            tooltip: {
                title: translate('delete'),
            },
            children: (
                <form
                    onSubmit={(e) => {
                        e.preventDefault()
                        setActive([])
                        p_.onDelete()
                    }}
                    className={cn(grid.colCenter, grid.p_mini)}
                >
                    <div className={cn(grid.w100, grid.mb_mini, textStyles.center)}>{translate('deleteApprove')}</div>
                    <div className={cn(grid.row, grid.justify)}>
                        <Button
                            type="submit"
                            mod="fill"
                            className={cn(grid.mr_mini)}
                            indentSize={'mini'}
                            textSize={'mini'}
                            rounded={'full_normal'}
                        >
                            {translate('yes')}
                        </Button>
                        <Button
                            mod={'withBorder'}
                            animation={false}
                            onClick={() => setActive([])}
                            indentSize={'mini'}
                            textSize={'mini'}
                            rounded={'full_normal'}
                        >
                            {translate('no')}
                        </Button>
                    </div>
                </form>
            ),
        }
    }

    if (!getUser()) return null

    const userId = getUser()!.id
    const uploadUrl = p_.upload
        ? `${config.api.root}${p_.upload}`
        : `${config.api.root}v2/upload/school/instances_catalog`
    const headers = getHeadersByType(p_.type)
    const uploaderHeaders: { [key: string]: string } = {
        ...headers,
        'SmartPlayer-From-User-Id': `${userId}`,
    }

    return (
        <div className={cn(styles.wrapper, isHorizontalMenu() && styles.wrapper_x)}>
            <div className={styles.content}>
                <div className={styles.tools}>
                    <div className={cn(grid.rowCenter)}>
                        {p_.onAdd && (
                            <div className={grid.mr_md}>
                                <Icon
                                    onClick={p_.onAdd}
                                    type={'plus_circle'}
                                    color={'grey'}
                                    tooltip={{ id: 'addItemTooltip', title: translate('add') }}
                                />
                            </div>
                        )}
                        <div className={styles.deleteButton}>
                            <DropMenu
                                active={active}
                                onChange={(active) => setActive(active)}
                                items={[deleteItem()]}
                                gray={true}
                            />
                        </div>
                    </div>
                    <div />
                    <div className={grid.row}>
                        <ModalWithBackground isOpen={openUploadModal} onClose={() => setOpenUploadModal(false)}>
                            <Uploader
                                uploadMethod={uploadUrl as ApiPostEventsType}
                                isModal={true}
                                onClose={() => setOpenUploadModal(false)}
                                headers={uploaderHeaders}
                            />
                        </ModalWithBackground>
                        <Button
                            mod={'withBorder'}
                            iconPos="left"
                            icon="upload_arrow"
                            className={cn(grid.mr_md)}
                            animation={false}
                            onClick={() => {
                                setOpenUploadModal(true)
                            }}
                        >
                            {translate('upload')}
                        </Button>
                    </div>
                </div>
                <div className={cn(grid.rowCenter, grid.p_md)}>{p_.title}</div>
            </div>
        </div>
    )
}

const mapStatToProps = (state: { user: { tokens: { accessToken: string; refreshToken: string } } }) => {
    return {
        tokens: state.user.tokens,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        startLoading: () => dispatch(loaderActions.startLoading()),
        endLoading: () => dispatch(loaderActions.endLoading()),
    }
}

export default connect(mapStatToProps, mapDispatchToProps)(InstancesCatalogFilter)
